export default "__VITE_ASSET__ac65bf18__"